import ChangeDocumentStatus from "../UseCase/ChangeDocumentStatus";
import DocumentRepository from "../Repository/DocumentRepository";
import getDatabase from "./database";

const changeDocumentStatus: ChangeDocumentStatus = new ChangeDocumentStatus(
    new DocumentRepository(getDatabase())
);

export default function getChangeDocumentStatus(): ChangeDocumentStatus {
    return changeDocumentStatus;
}